// The MIT License (MIT)
//
// Copyright (c) 2021 Camptocamp SA
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

export default class FormItem {
  /**
   * @param {Object} objects
   * @param {string} type
   */
  constructor(values, type) {
    if (!values || !type) {
      console.error(`Impossible to create ProNatura FormItem from: ${values}, ${type}`);
    }
    /**
     * @type {string}
     */
    this.id_ = values['fid'] ? `${values['fid']}` : `${values['ogc_fid']}`;
    if (this.id_ === 'undefined') {
      this.id_ = null;
    }

    /**
     * @type {string}
     */
    this.type_ = type;

    /**
     * @type {Object}
     */
    this.values_ = values;
  }

  /**
   * @return {string}
   */
  getId() {
    return this.id_;
  }

  /**
   * @param {string}
   */
  setId(id) {
    this.id_ = id;
  }

  /**
   * @return {Object}
   */
  getType() {
    return this.type_;
  }

  /**
   * @return {any}
   */
  getValue(key) {
    return this.values_[key];
  }

  /**
   * @return {Object}
   */
  getValues() {
    return this.values_;
  }
}
